export function smooth() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}